/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useI18n } from "intl/useI18n";
import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { getTitleCaseString } from "../utils";
import { useDtfStore } from "../store";
import "./MultiSizeGroup.scss";

export default function MultiSizeGroup({
  title = "",
  isPreset = false,
  count = 0,
  price = 0,
  showTitle = true,
  showDeleteButton = true,
  onDelete,
  onOpenSizeGuide,
  children,
  slots,
  ...restProps
}: any) {
  const { t, n } = useI18n();
  const store = useDtfStore();

  function showMultiSize() {
    // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
    return store.showMultiSize;
  }

  function isPricingLoading() {
    // @ts-expect-error TS(4111): Property 'isPricingLoading' comes from an index si... Remove this comment to see the full error message
    return store.isPricingLoading;
  }

  function showMultiSizeUI() {
    return showMultiSize() && showTitle;
  }

  function formattedTitle() {
    return getTitleCaseString(title);
  }

  function presetName() {
    return isPreset ? title : "custom";
  }

  function hasPrice() {
    return price != null && price !== "";
  }

  function handleDelete() {
    onDelete?.({
      preset: presetName()
    });
  }

  function openSizeGuide() {
    submitDtfEvent("our_sizing_guide_pressed", {
      placement: presetName()
    });
    onOpenSizeGuide?.(presetName());
  }

  return (
    <div
      {...restProps}
      className={cn("multi-size-group scope-cf354b75", restProps?.className, {
        "multi-size-group--simple": !showMultiSize() || !showTitle
      })}
    >
      {title && showMultiSizeUI() ? (
        <div className="multi-size-group__group-title scope-cf354b75">{formattedTitle()}</div>
      ) : null}
      {showMultiSizeUI() && showDeleteButton ? (
        <button
          className="multi-size-group__delete-button scope-cf354b75"
          type="button"
          onClick={handleDelete}
          data-testid="multi-size-group-delete-button"
        >
          <UseSvg
            className="multi-size-group__delete-button-icon scope-cf354b75"
            icon="modal-close-big"
            data-testid="multi-size-group-delete-button-icon"
          />
        </button>
      ) : null}
      {children}
      {showMultiSizeUI() ? (
        <div className="multi-size-group__footer scope-cf354b75">
          <div className="multi-size-group__footer-text scope-cf354b75">
            <span className="multi-size-group__footer-text-bold scope-cf354b75">
              {t("transfer", count)}
              {hasPrice() ? ":" : ""}
            </span>
            {hasPrice() ? (
              <span
                className={cn("multi-size-group__footer-text-price scope-cf354b75", {
                  "multi-size-group__footer-text-price--loading": isPricingLoading()
                })}
              >
                {n(price, "currency")}
              </span>
            ) : null}
          </div>
          {isPreset ? (
            <div
              className="multi-size-group__footer-link scope-cf354b75"
              onClick={openSizeGuide}
              data-testid="multi-size-group-footer-link"
            >
              {" "}
              Our Sizing Guide{" "}
            </div>
          ) : null}
        </div>
      ) : null}
      {slots?.footer?.()}
    </div>
  );
}
